import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import withNextStep from "../../components/hoc/withNextStep";
import Step2 from './Step3-redux';

export default compose(
  withRouter,
  withNextStep
)(Step2);
